/** In-memory fallback storage (non-persistent). */
export class InMemoryPasskeyStorage {
    constructor() {
        this.credentialIds = [];
        this.activeId = null;
    }
    getActiveCredentialId() { return this.activeId; }
    getAllCredentialIds() { return [...this.credentialIds]; }
    storeCredentialId(credId) {
        if (!this.credentialIds.includes(credId)) {
            this.credentialIds.push(credId);
        }
        this.activeId = credId;
    }
    removeCredentialId(credId) {
        this.credentialIds = this.credentialIds.filter(id => id !== credId);
        if (this.activeId === credId) {
            this.activeId = this.credentialIds[0] ?? null;
        }
    }
}
